<display-form [displayObject]="displayObject"></display-form>

<div *ngIf="previousJustifications.length > 0" class="mt-4">
    <h5>Previous justification attempts ({{ previousJustifications.length }})</h5>
    <p class="text-muted">Justifications the requestor already submitted and the AI's decision for each.</p>
    <div *ngFor="let item of previousJustifications; let i = index" class="card mb-2">
        <div class="card-body">
            <div class="d-flex justify-content-between">
                <strong>Attempt {{ i + 1 }}</strong>
                <span class="text-muted" *ngIf="item.attemptedDate">{{ item.attemptedDate | date:'medium' }}</span>
            </div>
            <div class="mt-1">
                <span class="badge bg-secondary" *ngIf="item.aiDecision">AI: {{ item.aiDecision }}</span>
                <span class="badge bg-info text-dark ms-1" *ngIf="item.cycleStatus">{{ item.cycleStatus }}</span>
            </div>
            <blockquote class="mb-0 mt-2">{{ item.justification }}</blockquote>
        </div>
    </div>
</div>
